import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"margin":"10px","color":"red"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_stop_outlined = _resolveComponent("stop-outlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      model: _ctx.formState,
      name: "basic",
      autocomplete: "off",
      onFinish: _ctx.onFinish,
      onFinishFailed: _ctx.onFinishFailed
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: "店舗",
          name: "shopcode",
          rules: [{ required: true, message: 'Please select your Shop!' }],
          "label-col": { span: 4 },
          "wrapper-col": { span: 16 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: _ctx.formState.shopcode,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.shopcode) = $event)),
              options: _ctx.shoplist,
              style: {"text-align":"left"}
            }, null, 8, ["value", "options"])
          ]),
          _: 1
        }),
        (!_ctx.pharmacyMode)
          ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 0,
              label: "Code",
              name: "code",
              rules: [{ required: true, message: 'Please input your Code!' }],
              "label-col": { span: 4 },
              "wrapper-col": { span: 16 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.code,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.code) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form_item, {
          label: "Password",
          name: "password",
          rules: [{ required: true, message: 'Please input your password!' }],
          "label-col": { span: 4 },
          "wrapper-col": { span: 16 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: _ctx.formState.password,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.password) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("管理者でログイン")
              ]),
              _: 1
            }),
            (_ctx.visible)
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                  _createVNode(_component_stop_outlined, { style: {"margin-right":"10px"} }),
                  _createTextVNode("ログインに失敗しました")
                ]))
              : _createCommentVNode("", true),
            _hoisted_2,
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { style: {"margin-top":"20px"} }, {
                  default: _withCtx(() => [
                    _createTextVNode("配送者ページに移動")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "onFinish", "onFinishFailed"]),
    _createVNode(_component_a_divider, {
      style: {"border-color":"#000"},
      dashed: ""
    })
  ], 64))
}